import React, { useContext, useState, useEffect } from 'react'

import { connect } from 'react-redux'

import { numCol, dateCol, intCol } from '@integec/grid-tools/lib/cols'
// import { Button, DatePicker, Select, message, InputNumber } from 'antd'
import {
  Button,
  DatePicker,
  Select,
  InputNumber,
  Upload,
  message,
  Icon,
} from 'antd'
import {
  getGenerationAux,
  deleteGenerationAuxInfo,
  postGenerationAuxInfo,
  getAuthorization,
  getCredentials,
} from 'api/pgads.js'
import {
  DatePickerContext,
  ErrorContext,
  JcTmpErrorContext,
  SpinContext,
  // ErrorContext,
  // SpinContext,
  // UnitSelectionContext,
} from 'context'
import {
  getEnvConfig,
  getPermitActions,
  getApiTargetInfo,
  UtilityUnitSelection,
} from 'core'
import CommonScreen from '../admin/component/CommonScreen'
import {
  modifiedDateCol,
  modifierCol,
  utilityHeader,
  unitIdHeader,
} from 'core/HeaderColTypeProps'
import {
  getClientInfo,
  getUnitNameMap,
  getUnits,
  getUtilityNameMap,
  getValidYearRange,
} from 'core/selectors'

import R from 'ramda'
import { hasAccesPermits, isValidYearRange } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import { Label } from 'core/screen-util'

import { isErrorContains } from 'core/component/JcTmpErrorDialog'
// import { Filler } from 'core/screen-util'

const { Option } = Select

const title = 'Generation'

const ViewGenerationHeaders = [
  utilityHeader,
  unitIdHeader,
  dateCol({ ident: 'transDate', display: 'Transdate', isKey: true }),
  intCol({ ident: 'hour', display: 'Hour', isKey: true }),
  numCol({
    ident: 'netGeneration',
    display: 'Net Generation',
    isFiltered: true,
    isEditable: true,
  }),
  numCol({
    ident: 'stationService',
    display: 'Station Service',
    isFiltered: true,
    isEditable: true,
  }),
  numCol({
    ident: 'pumpPower',
    display: 'Pump Power',
    isFiltered: true,
    isEditable: true,
  }),
  numCol({
    ident: 'onlineAux',
    display: 'Online Aux',
    isFiltered: true,
    isEditable: true,
  }),
  numCol({
    ident: 'offlineAux',
    display: 'Offline Aux',
    isFiltered: true,
    isEditable: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const modifyTask = apiTargetInfo => data =>
  postGenerationAuxInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteGenerationAuxInfo(apiTargetInfo)(data)

const hourOption = R.range(1, 24).map(i => ({
  key: `${i}`,
  value: `${i}`,
  text: `${i}`,
}))

const GenerationAux = ({
  apiTargetInfo,
  utilityNameMap,
  unitNameMap,
  envConfig,
  actionPermits,
}) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [withoutModify, setWithoutModify] = useState(true)
  // const { selectedDateRangePicker } = useContext(DatePickerContext)

  // const { selectedUnits } = useContext(UnitSelectionContext)

  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )

  useEffect(() => {
    const isAdmin = hasAccesPermits({
      authGodMode: envConfig.authGodMode,
      actionPermits,
      eventActions: [ScreenPermissions.ADMIN_GENERATION_AUX],
      matchAny: true,
    })
    setWithoutModify(!isAdmin)
  }, [actionPermits, envConfig.authGodMode])

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns:
          '150px 120px 120px 120px 120px 120px 120px 120px 120px 120px auto',
        gap: 5,
      }}
    >
      <Label>Utility / Unit :</Label>

      <div style={{ gridColumnEnd: 'span 5', width: '100%' }}>
        <UtilityUnitSelection
          className="utilityUnit"
          utility={insertData.utility}
          unit={insertData.unit}
          onUnitChange={value => {
            // setUtilityUnit(value)
            setInsertData({
              ...insertData,
              utility: value[0],
              unit: value[1].substr(value[0].length),
              unitId: value[1],
            })
          }}
          casStyle={{ width: '100%' }}
        />
      </div>

      <Label>Trans Date :</Label>

      <DatePicker
        className="transDate"
        style={{ width: '100%' }}
        onChange={date =>
          setInsertData({
            ...insertData,
            transDate: date.format('YYYY-MM-DD'),
            transDate2: date,
            // transDate: date,
          })
        }
        value={insertData.transDate2}
        placeholder="Trans Date"
        format="MM/DD/YYYY"
        allowClear={false}
      />

      <Label>Hour :</Label>

      <Select
        className="hour"
        value={insertData.hour}
        // style={{ minWidth: '150px' }}
        onChange={value => setInsertData({ ...insertData, hour: value })}
        style={{ width: '100%' }}
      >
        {hourOption.map(m => (
          <Option key={m} value={m.key}>
            {m.value}
          </Option>
        ))}
      </Select>
      <div />

      <Label>Net Generation :</Label>

      <InputNumber
        style={{ width: '100%' }}
        className="netGeneration"
        defaultValue={0}
        onChange={value =>
          setInsertData({ ...insertData, netGeneration: value })
        }
      />

      <Label>Station Service :</Label>

      <InputNumber
        style={{ width: '100%' }}
        className="stationService"
        defaultValue={0}
        onChange={value =>
          setInsertData({ ...insertData, stationService: value })
        }
      />

      <Label>Pump Power :</Label>

      <InputNumber
        style={{ width: '100%' }}
        className="pumpPower"
        defaultValue={0}
        onChange={value => setInsertData({ ...insertData, pumpPower: value })}
      />

      <Label>Online Aux :</Label>

      <InputNumber
        style={{ width: '100%' }}
        className="onlineAux"
        defaultValue={0}
        onChange={value => setInsertData({ ...insertData, onlineAux: value })}
      />

      <Label>Offline Aux :</Label>

      <InputNumber
        style={{ width: '100%' }}
        className="OfflineAux"
        defaultValue={0}
        onChange={value => setInsertData({ ...insertData, offlineAux: value })}
      />
      <div
        style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 5 }}
      >
        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>

        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>

        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  )

  const headerWithFormatter = ViewGenerationHeaders.map(header => {
    if (header.ident === 'utility') {
      return {
        ...header,
        rowHeaderBackgroundColor: '#eee',
        dataFormatter: ({ value }) => utilityNameMap[value] || value,
        sortIndexGetter: ({ rowData }) =>
          `${rowData.utility}-${utilityNameMap[rowData.utility]}` ||
          rowData.utility,
      }
    }
    if (header.ident === 'unitId') {
      return {
        ...header,
        rowHeaderBackgroundColor: '#eee',
        dataFormatter: ({ value }) => unitNameMap[value] || value,
        sortIndexGetter: ({ rowData }) =>
          `${rowData.utility}-${unitNameMap[rowData.unitId]}` || rowData.unitId,
      }
    }
    return header
  })
  // const screenCriteria = (state,props,selUnits)=>{
  const screenCriteria = (s, p, u, onCriteriaChnage) => {
    return (
      <DatePicker.RangePicker
        style={{ marginLeft: '0px' }}
        allowClear={false}
        format="MM/DD/YYYY"
        value={selectedDateRangePicker}
        onChange={d => {
          setSelectedDateRagePicker(d)
          onCriteriaChnage()
          // retrieve({ dates: d })
        }}
      />
    )
  }

  const beforeRetrieveValidation = ({ validYearRange }) => {
    return isValidYearRange(
      validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
  }
  const { setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const { setTmpError } = useContext(JcTmpErrorContext)

  const isclecoImportGeneration = hasAccesPermits({
    authGodMode: envConfig.authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.CLECO_GENERATION_IMPORT],
    matchAny: true,
  })
  const fileProps = {
    name: 'file',
    action: `${apiTargetInfo.baseUrl}/cleco/generation-import`,
    method: 'POST',
    data: {},
    headers: getAuthorization(apiTargetInfo),
    ...getCredentials(apiTargetInfo),
  }
  const extraCriteriaAfterButton = ({ onRetrieve }) => {
    if (!withoutModify)
      if (isclecoImportGeneration)
        return (
          <Upload
            {...fileProps}
            beforeUpload={_ => setSpinning(true)}
            onChange={data => {
              if (data.file.status === 'done') {
                setSpinning(false)
              }
              if (
                data.file.response &&
                data.file.response.restfulStatus &&
                data.file.response.restfulStatus === 'FAILURE'
              ) {
                setError(data.file.response)
              }
              if (data.file.status === 'done' && data.file.response) {
                const tmpError = data.file.response
                if (tmpError.length > 0) setTmpError(tmpError)
                if (!isErrorContains(tmpError)) {
                  message.success('File imported successfully')
                  onRetrieve()
                }
              }
            }}
            multiple={false}
            showUploadList={false}
          >
            <Button type="danger">
              <Icon type="upload" /> Import
            </Button>
          </Upload>
        )
    return <div />
  }
  return (
    <CommonScreen
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      beforeRetrieveValidation={beforeRetrieveValidation}
      key="viewGeneration"
      title={title}
      header={headerWithFormatter}
      saveTask={modifyTask}
      retrieveTask={getGenerationAux}
      withCriteria={(state, props, selectedUnits) => ({
        units: selectedUnits,
        startDate: selectedDateRangePicker[0],
        endDate: selectedDateRangePicker[1],
      })}
      withUnitSelection
      deleteTask={deleteTask}
      autoRetrieve={false}
      altBy={d => d.unitId}
      sortOptions={[utilityHeader, unitIdHeader]}
      insertComp={insertEvent && insertComp}
      insertCompHeight={150}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      defaultInsertData={{
        hour: 1,
        netGeneration: 0,
        stationService: 0,
        pumpPower: 0,
        offlineAux: 0,
        onlineAux: 0,
      }}
      withoutModify={withoutModify}
      withDatePicker={false}
      screenCriteria={screenCriteria}
      allowInsert={!withoutModify}
      autoFixColByKey={false}
      isAdminScreen={false}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  units: getUnits(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  validYearRange: getValidYearRange(state),
  CLIENT: getClientInfo(state),
})

export default connect(mapStateToProps)(GenerationAux)
